import React, { useState, useRef, useEffect } from 'react';
import analyticsEvent from 'services/analytic/analytic-service';
import getBrandLogoUrl from 'utilities/brandLogo/getBrandLogoUrl';
import { DeliveryAndReturnContentItem, DeliveryAndReturnContentKey } from 'types/Product';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { DeliveryAndReturnsProps } from './DeliveryAndReturnsProps';
import DeliveryAndReturnsModal from './Dialog/DeliveryAndReturnsDialog';
import DeliveryCard from './Card/DeliveryCard';

const DEFAULT_CONTENT: DeliveryAndReturnContentItem = {
  pageText: 'Please select an option to view delivery options on this item',
  pageLink: '',
  modalHeading: '',
  modalBody: '',
};

function DeliveryAndReturns(props: DeliveryAndReturnsProps) {
  const { brand, content, contentKey } = props;
  const { selectedSku } = useSelectedSkuContext();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogRendered, setDialogRendered] = useState(false);
  const isFirstRender = useRef(true);
  const selectedContentKey = contentKey || selectedSku?.deliveryAndReturnContentKey;
  const selectedContent = (selectedContentKey && content[`${selectedContentKey}`]) || DEFAULT_CONTENT;
  const brandLogoUrl =
    brand && selectedContentKey === DeliveryAndReturnContentKey.FFM ? getBrandLogoUrl(brand) : undefined;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (dialogRendered) {
      setDialogOpen(true);
    }
  }, [dialogRendered]);

  const sendAnalyticsEvent = (action: 'Open' | 'Closed') => {
    if (selectedContentKey) {
      analyticsEvent({
        gaLabel: `Delivery and Returns - ${selectedContentKey} - ${selectedContent.pageLink} - ${action}`,
      });
    }
  };

  const openDialog = () => {
    if (dialogRendered) {
      setDialogOpen(true);
    } else {
      setDialogRendered(true);
    }

    sendAnalyticsEvent('Open');
  };

  const closeDialog = () => {
    setDialogOpen(false);
    sendAnalyticsEvent('Closed');
  };

  return (
    <div data-testid="delivery-and-returns">
      <DeliveryCard onClick={openDialog} text={selectedContent.pageText} link={selectedContent.pageLink} />

      {dialogRendered && (
        <DeliveryAndReturnsModal
          body={selectedContent.modalBody}
          brand={brand}
          brandLogoUrl={brandLogoUrl}
          heading={selectedContent.modalHeading}
          onClose={closeDialog}
          open={dialogOpen}
        />
      )}
    </div>
  );
}

export default DeliveryAndReturns;
